import React, { useState } from "react";

import Logo from "../imgs/full-logo.svg";
import { Link, useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const [isSidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleScroll = (id) => {
    if (location.pathname !== "/") {
      navigate(`/#${id}`);
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 100); // Small delay for navigation to complete
    } else {
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);

  return (
    <header className="bg-white fixed top-0 left-0 w-full z-50">
      <div className="max-w-7xl mx-auto px-4 lg:px-0 flex justify-between items-center h-20">
        {/* Logo */}
        <Link to={"/"}>
          <img src={Logo} alt="Logo" loading="eager" className="h-6 w-auto" />
        </Link>

        {/* Navigation for larger screens */}
        <nav className="hidden lg:flex space-x-6">
          <button
            onClick={() => handleScroll("about")}
            className="text-gray-700 text-sm font-medium"
          >
            About
          </button>
          <button
            onClick={() => handleScroll("hiw")}
            className="text-gray-700 text-sm font-medium"
          >
            How It Works
          </button>
          <button
            onClick={() => handleScroll("faq")}
            className="text-gray-700 text-sm font-medium"
          >
            FAQs
          </button>
          <Link
            to="/patrons"
            className="text-gray-700 text-sm font-medium"
            style={{
              paddingBottom: location.pathname == "/patrons" ? 1 : 0,
              borderBottomWidth: location.pathname == "/patrons" ? 2 : 0,
              borderBottomColor: "#3BF5CA",
            }}
          >
            Patrons
          </Link>
        </nav>

        {/* Auth buttons for larger screens */}
        <div className="hidden lg:flex space-x-4">
          <a
            href="https://app.hallimo.com/login"
            className="px-4 py-2 text-[#052035] border border-[#052035] rounded-md"
          >
            Login
          </a>
          <a
            href="https://app.hallimo.com/register"
            className="px-4 py-2 bg-[#3BF5CA] border text-[#052035] border-[#052035]  rounded-md"
          >
            Signup
          </a>
        </div>

        {/* Hamburger Menu for mobile */}
        <button
          className="lg:hidden text-gray-700 focus:outline-none"
          onClick={toggleSidebar}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M4 6h16M4 12h16m-7 6h7"
            />
          </svg>
        </button>
      </div>

      {/* Sidebar */}
      <div
        className={`fixed top-0 right-0 h-full bg-white shadow-lg w-2/3 max-w-xs transform transition-transform duration-300 ease-in-out ${
          isSidebarOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="p-4 flex justify-end items-center border-b border-gray-200">
          <button
            className="text-gray-700 focus:outline-none"
            onClick={toggleSidebar}
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <nav className="p-4 space-y-4">
          <button
            onClick={() => handleScroll("about")}
            className="block text-gray-700"
          >
            About
          </button>
          <button
            onClick={() => handleScroll("hiw")}
            className="block text-gray-700"
          >
            How It Works
          </button>
          <button
            onClick={() => handleScroll("faq")}
            className="block text-gray-700"
          >
            FAQs
          </button>
          <Link to="/patrons" className="block text-gray-700">
            Patrons
          </Link>
        </nav>

        <div className="p-4 border-t border-gray-200">
          <a href="https://app.hallimo.com/login">
            <button className="mb-4 w-full px-4 py-2 text-[#052035] border border-[#052035] rounded-md">
              Login
            </button>
          </a>

          <a href="https://app.hallimo.com/register">
            <button className="w-full px-4 py-2 bg-[#3BF5CA] border text-[#052035] border-[#052035]  rounded-md">
              Signup
            </button>
          </a>
        </div>
      </div>
    </header>
  );
};

export default Header;
